<template>
  <v-text-field
  v-model="model"
  :rules="rules"
  :disabled="disabled"
  hide-details="auto"
  :class="`sts-web-system-label ${disabled ? 'v-input--is-readonly' : ''}`"
  :label="$t('textFields.countryCode')">
  </v-text-field>
</template>
<script>
export default {
  props: {
    required: Boolean,
    value: String,
    disabled: Boolean
  },
  model: {
    prop: 'value',
    event: 'valueChanged'
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit('valueChanged', v)
      }
    }
  },
  data() {
    return {
      rules: [
        (v) => this.required ? !!v || this.$t('invalidValue.required') : true,
        (v) => new RegExp(/^[a-zA-ZА-Яа-я]{2}$/).test(v) || this.$t('invalidValue._2LettersOnly'),
      ]
    }
  }
}
</script>
<style>
.sts-web-system-label  .v-label.theme--light {
  font-family: 'Titillium Web', sans-serif;
  font-weight: 300;
}
</style>